import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import withIconWrapper from 'app/hocs/withIconWrapper';

export default withIconWrapper(function NoticeInfo({ color, size, ...props }) {
  return (
    <Svg fill="none" height={size} viewBox="0 0 18 18" width={size} {...props}>
      <Path
        d="M7.875 5.34375C7.875 4.8795 8.2545 4.5 8.71875 4.5H9.28125C9.7455 4.5 10.125 4.8795 10.125 5.34375V5.90625C10.125 6.3705 9.7455 6.75 9.28125 6.75H8.71875C8.2545 6.75 7.875 6.3705 7.875 5.90625V5.34375ZM11.25 13.5H6.75V12.375H7.875V9H6.75V7.875H10.125V12.375H11.25V13.5ZM9 0C4.02975 0 0 4.02975 0 9C0 13.9703 4.02975 18 9 18C13.9703 18 18 13.9703 18 9C18 4.02975 13.9703 0 9 0ZM9 16.3125C4.96125 16.3125 1.6875 13.0387 1.6875 9C1.6875 4.96125 4.96125 1.6875 9 1.6875C13.0387 1.6875 16.3125 4.96125 16.3125 9C16.3125 13.0387 13.0387 16.3125 9 16.3125Z"
        fill={color}
      />
    </Svg>
  );
});
